import { main } from './main.js'

// Components
import { AchatMobile } from '../components/achat-mobile/achat-mobile.jsx'
import { AlertInfo } from '../components/alert-info/alert-info.jsx'
import { BandeAccueil } from '../components/bande-accueil/bande-accueil.jsx'
import { BandeAccueilTv, bandeAccueilTvState } from '../components/bande-accueil-tv/bande-accueil-tv.jsx'
import { Bandeau } from '../components/bandeau/bandeau.jsx'
import { BandeEcommerce } from '../components/bande-ecommerce/bande-ecommerce.jsx'
import { BandeEquipements } from '../components/bande-equipements/bande-equipements.jsx'
import { BandeListeContrats } from '../components/bande-liste-contrats/bande-liste-contrats.jsx'
import { BandeMentionsLegales } from '../components/bande-mentions-legales/bande-mentions-legales.jsx'
import { BandeOptionsEquipement, bandeOptionsEquipementState } from '../components/bande-options-equipement/bande-options-equipement.jsx'
import { BandeParcoursMarchand } from '../components/bande-parcours-marchand/bande-parcours-marchand.jsx'
import { Carrousel } from '../components/carrousel/carrousel.jsx'
import { EditoTv } from '../components/edito-tv/edito-tv.jsx'
import { FilAriane } from '../components/fil-ariane/fil-ariane.jsx'
import { Foisonnement } from '../components/foisonnement/foisonnement.jsx'
import { JeuMarathon2024 } from '../components/jeu-marathon-2024/jeu-marathon-2024.jsx'
import { JeuxVideo } from '../components/jeux-video/jeux-video.jsx'
import { Jo2024 } from '../components/jo-2024/jo-2024.jsx';
import { JoCountdown } from '../components/jo-countdown/jo-countdown.jsx'
import { MagTv } from '../components/mag-tv/mag-tv.jsx'
import { Menu } from '../components/menu/menu.jsx'
import { MenuOse } from '../components/menu-ose/menu-ose.jsx'
import { Music, musicState } from '../components/music/music.jsx'
import { News, newsState } from '../components/news/news.jsx'
import { ParcoursNouveauteInternet } from '../components/parcours-nouveaute-internet/parcours-nouveaute-internet.jsx'
import { ParcoursNouveautePlus } from '../components/parcours-nouveaute-plus/parcours-nouveaute-plus.jsx'
import { PersoReco } from '../components/perso-reco/perso-reco.jsx'
import { PrefooterSeo } from '../components/prefooter-seo/prefooter-seo.jsx'
import { Publicite } from '../components/publicite/publicite.jsx'
import { BandePushFidelisation } from '../components/bande-push-fidelisation/bande-push-fidelisation.jsx'
import { ReassuranceBoutique } from '../components/reassurance-boutique/reassurance-boutique.jsx'
import { ReassuranceEquipement, reassuranceEquipementState } from '../components/reassurance-equipement/reassurance-equipement.jsx'
import { ReassuranceReseau } from '../components/reassurance-reseau/reassurance-reseau.jsx'
import { ReassuranceService } from '../components/reassurance-service/reassurance-service.jsx'
import { RecoEquipements, recoEquipementsState } from '../components/reco-equipements/reco-equipements.jsx'
import { RecoParcoursProspect } from '../components/reco-parcours-prospect/reco-parcours-prospect.jsx'
import { ReassuranceTv } from '../components/reassurance-tv/reassurance-tv.jsx'
import { SecondContract } from '../components/second-contract/second-contract.jsx'
import { SeoKeywords } from '../components/seo-keywords/seo-keywords.jsx'
import { TvLiveReplay, tvLiveReplayState } from '../components/tv-live-replay/tv-live-replay.jsx'
import { Vod, vodState } from '../components/vod/vod.jsx'

// Specific orchestrators
import { metadataOrchestrator } from './componentsOrchestrator/metadataOrchestrator.js'

/*
 * Config.events Options
 *
 *  - check             {array}         vérifie que les données du tableau sont bien présentes
 *  - component         {Component}     composant à afficher
 *  - data              {object}        données supplémentaires à passer au composant
 *  - dynamicPosition   {boolean}       si true, utilise la position dynamique
 *  - elementId         {string}        id de l'élément dans le DOM
 *  - noData            {boolean}       si true, ne vérifie pas les données
 *  - orchestrator      {function}      fonction spécifique d'orchestration
 *  - state             {signal}        si présent, utilise le state pour afficher le composant
 *  - shadowDOM         {boolean}       si true, utilise le shadowDOM pour afficher le composant
 *  - shadowStyle       {string}        si présent, injecte le style dans le shadowDOM
 */
const config = {
    ssePath: {
        hp: 'api/events/accueils/portail',
        tv: 'api/events/accueils/tv',
        mobile: 'api/events/accueils/mobile',
        boutique: 'api/events/accueils/boutique',
    },
    events: {
        achatForfait: { elementId: 'achatForfait', component: AchatMobile, check: ['items'] },
        achatMobile: { elementId: 'achatMobile', component: AchatMobile, check: ['items'] },
        alerteInfo: { elementId: 'alertInfo', component: AlertInfo },
        bandeAccueilTv: { state: bandeAccueilTvState, elementId: 'bandeAccueilTv', component: BandeAccueilTv, data: { format: '1200x388-960x1040', marginBottom: '' } },
        BandeListesContrats: { elementId: 'listeContrats', component: BandeListeContrats },
        carrousel_hpProspect: { elementId: 'carrousel', component: Carrousel, data: { format: '1200x475-960x800', marginBottom: '' } },
        carrousel_n1Forfait: { elementId: 'carrousel', component: Carrousel, data: { format: '1440x310-960x1040', marginBottom: 'mb-2' } },
        carrousel_hpRegulier: { elementId: 'carrousel', component: Carrousel, data: { format: '1440x310-960x800', marginBottom: 'mb-0 mb-md-2' } },
        carrousel_hpOccasionnel: { elementId: 'carrousel', component: Carrousel, data: { format: '1440x310-960x800', marginBottom: 'mb-0 mb-md-2' } },
        carrousel_boutique: { elementId: 'carrousel', component: Carrousel, data: { format: '1440x310-960x800', marginBottom: 'mb-2' } },
        editoTv: { elementId: 'editoTv', component: EditoTv },
        equipments: { elementId: 'bandeEquipements', component: BandeEquipements, dynamicPosition: true, check: ['items'] },
        event: { elementId: 'event', component: Bandeau, data: { closeButton: true } },
        filAriane: { elementId: 'filAriane', component: FilAriane, check: ['items'] },
        foisonnement: { elementId: 'foisonnement', component: Foisonnement },
        jeuMarathon2024: { elementId: 'jeuMarathon2024', component: JeuMarathon2024 },
        jeuxVideo: { elementId: 'jeuxVideo', component: JeuxVideo, check: ['URL'] },
        jo2024: { elementId: 'jo2024', component: Jo2024, noData: true },
        joCountDown: { elementId: 'joCountdown', component: JoCountdown },
        legalNotices: { elementId: 'mentionsLegales', component: BandeMentionsLegales, check: ['notes'] },
        magTv: { elementId: 'magTv', component: MagTv },
        menu: { elementId: 'menu', component: Menu, check: ['items'] },
        menuOse: { elementId: 'menuOse', component: MenuOse },
        metaData: { orchestrator: metadataOrchestrator },
        music: { state: musicState, elementId: 'music', component: Music },
        news: { state: newsState, elementId: 'news', component: News },
        offreEtOptions: { state: bandeOptionsEquipementState, elementId: 'bande-options', component: BandeOptionsEquipement },
        parcours: { elementId: 'recoParcoursProspect', component: RecoParcoursProspect, check: ['items'] },
        parcoursMarchand: { elementId: 'bande-parcours-marchand', component: BandeParcoursMarchand, check: ['recommendations'] },
        parcoursMarchandNouveauteInternet: { elementId: 'bande-parcours-nouveaute-internet', component: ParcoursNouveauteInternet, check: ['cards'] },
        parcoursMarchandNouveauteMobileProspect: { elementId: 'parcoursNouveautePlusMobileForfait', component: ParcoursNouveautePlus, check: ['items'] },
        parcoursMarchandNouveauteInternetProspect: { elementId: 'parcoursNouveautePlusInternetFix', component: ParcoursNouveautePlus, check: ['items'] },
        parcoursNouveaute: { elementId: 'parcours4nouveautes', component: BandeParcoursMarchand, check: ['recommendations'] },
        persoReco: { elementId: 'persoReco', component: PersoReco },
        pourquoiChoisirOrange: { elementId: 'reassuranceBoutique', component: ReassuranceBoutique, check: ['items'] },
        prefooter: { elementId: 'prefooterSeoTmp', component: PrefooterSeo },
        pubLienscommerciaux: { elementId: 'pubLienscommerciaux', component: Publicite, data: { type: 'lienscommerciaux' } },
        pubMasthead1: { elementId: 'pubMasthead1', component: Publicite, data: { type: 'masthead1' } },
        pubMasthead2: { elementId: 'pubMasthead2', component: Publicite, data: { type: 'masthead2' } },
        pubNative: { elementId: 'pubNative', component: Publicite, data: { type: 'native' } },
        pubRM: { elementId: 'pubRm', component: Publicite, data: { type: 'rm' } },
        pushFidelisation: { elementId: 'pushFidelisation', component: BandePushFidelisation, check: ['recommendations'] },
        rassuranceEcommerce: { elementId: 'ecommerce', component: BandeEcommerce, check: ['items'] },
        rassuranceReseau: { elementId: 'reassuranceReseau', component: ReassuranceReseau },
        rassuranceService: { elementId: 'rassuranceService', component: ReassuranceService, check: ['items'] },
        rassuranceTv: { elementId: 'reassuranceTv', component: ReassuranceTv },
        recoEquipements: { state: recoEquipementsState, elementId: 'recoEquipements', component: RecoEquipements, dynamicPosition: true },
        reassuranceEquipments: { state: reassuranceEquipementState, elementId: 'reassuranceEquipement', component: ReassuranceEquipement, dynamicPosition: true, check: ['items'] },
        secondContract: { elementId: 'secondContract', component: SecondContract },
        seoKeywords: { elementId: 'seoKeywords', component: SeoKeywords },
        tv: { state: tvLiveReplayState, elementId: 'tvLiveReplay', component: TvLiveReplay },
        vod: { state: vodState, elementId: 'vod', component: Vod, check: ['items'] },
        zonePerso: { elementId: 'zonePerso', component: BandeAccueil },
    }
}

export const sg1Start = (profile, context) => {
    main(config, profile, context)
}

const getMarginBottom = () => {

}